import { render } from "./MTag.vue?vue&type=template&id=130ab1ba&scoped=true"
import script from "./MTag.vue?vue&type=script&lang=js"
export * from "./MTag.vue?vue&type=script&lang=js"

import "./MTag.vue?vue&type=style&index=0&id=130ab1ba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130ab1ba"]])

export default __exports__